import { useParams, Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Section, Container, Btn, ArrowLink, Crumbs } from "@/components/kit";
import { Eyebrow } from "@/lib/anim";
import { ARTICLES, SERVICES } from "@/lib/content";
import NotFound from "@/pages/NotFound";

export default function Article() {
  const { slug } = useParams();
  const a = ARTICLES.find((x) => x.slug === slug);
  if (!a) return <NotFound />;
  const svc = SERVICES[a.related];
  const idx = ARTICLES.findIndex((x) => x.slug === slug);
  const next = ARTICLES[(idx + 1) % ARTICLES.length];
  const jsonLd = {
    "@context": "https://schema.org", "@type": "Article", headline: a.title,
    description: a.excerpt, author: { "@type": "Person", name: "Rasika Khode" },
    publisher: { "@type": "Organization", name: "Prox" },
  };

  return (
    <>
      <Seo title={a.title} canonical={`/insights/${slug}`} description={a.excerpt} type="article" jsonLd={jsonLd} />
      <section className="pt-16 md:pt-24 pb-12 border-b border-[var(--stone)]" style={{ backgroundColor: "var(--bone)" }}>
        <Container size="md">
          <Crumbs items={[{ label: "Home", to: "/" }, { label: "Insights", to: "/insights" }, { label: a.tag }]} />
          <Eyebrow>{a.tag}</Eyebrow>
          <h1 className="t-display2">{a.title}</h1>
          <p className="t-lead mt-6 text-[var(--muted)]">{a.excerpt}</p>
        </Container>
      </section>

      <Section bg="bone">
        <Container size="md" className="!px-0">
          <div className="prose">
            {a.body.map((p) => <p key={p}>{p}</p>)}
          </div>

          {svc && (
            <div className="card p-8 mt-14" data-testid="article-related">
              <span className="eyebrow">Related service</span>
              <h2 className="t-h3 mt-3">{svc.title}</h2>
              <p className="t-body text-[var(--muted)] mt-3">{svc.lead}</p>
              <ArrowLink to={`/services/${a.related}`} className="mt-6">See the service</ArrowLink>
            </div>
          )}

          <div className="mt-10 flex flex-wrap items-center justify-between gap-4">
            <ArrowLink to={`/insights/${next.slug}`}>Next: {next.title}</ArrowLink>
            <Btn to="/book" variant="clay">Book the fit call</Btn>
          </div>
        </Container>
      </Section>
    </>
  );
}
